<template>
  <div>
    <plt-page-title>筛选框</plt-page-title>
    <el-form :model="queryParams" inline label-width="110px">
      <el-form-item label="租借人" v-if="includeList.length">
        <plt-dict-select v-model="queryParams.leaseeId" namespace="bizObjects" id="member" :include="includeList" />
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input v-model="queryParams.vehicleLicenseLike" clearable placeholder="请输入" />
      </el-form-item>

      <el-form-item label="收货地址">
        <el-input v-model="queryParams.receiveAddressLike" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="中化交付单号">
        <el-input v-model="queryParams.deliveryId" clearable placeholder="请输入" />
      </el-form-item><br>
      <el-form-item label="出库日期">
        <el-date-picker v-model="queryParams.dateTime" @change="onDate" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" style="width:215px"></el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="onQuery">查询</el-button>
    </el-form>
    <plt-page-title>交付列表</plt-page-title>
    <plt-table ref="tableRef" :url="queryUrl" paramName="param" :queryParams="queryParams" exportId="queryZHDeliveryPlans" exportFileName="交付列表">
      <el-table-column label="普拉托交付计划号" prop="deliveryPlanId" />
      <el-table-column label="中化交付单号" prop="deliveryId" />
      <plt-table-dict-col label="租借人" prop="leaseeId" namespace="bizObjects" id="member" />
      <plt-table-dict-col label="标的物小类" prop="targetType" namespace="target" id="type" />
      <plt-table-dict-col label="出库仓库" prop="storageId" namespace="bizObjects" id="warehouse" />
      <plt-table-formatter-col label="出库日期" prop="shippingDate" formatter="date"/>
      <el-table-column label="车牌号" prop="vehicleLicense" />
      <el-table-column label="收货地址" prop="receiveAddress" />
      <el-table-column label="收货人" prop="receiveLinkmanName" />
      <el-table-column label="收货人电话" prop="receiveLinkmanMobile" />
      <el-table-column label="总数量" prop="totalAmount" />
      <el-table-column label="已签收数量" prop="finishAmount" />
      <plt-table-formatter-col label="签收时间" prop="confirmTime" formatter="date"/>
      <el-table-column label="停租数量" prop="depositAmount" />
      <el-table-column label="回收数量" prop="recycledAmount" />
      <el-table-column label="在租数量" prop="billingAmount" />
      <el-table-column label="操作" fixed="right" width="100px">
          <template #default="{row}">
              <el-button type="warning" v-show="row.eReceiptFlag == '1'" size="mini" @click="onLockSigin(row.deliveryId,row.leaserId)">电子签收单</el-button>
          </template>
      </el-table-column>
    </plt-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryUrl: 'http://MID-OPERATE-LEASE/messageService/zhService/queryZHDeliveryPlans',
      queryParams: {
        leaseeId: "",
        vehicleLicenseLike: "",
        receiveAddressLike: "",
        deliveryId: "",
        shippingDateBegin: "",
        shippingDateEnd: "",
      },
      includeList: []
    }
  },
  watch: {
    "queryParams.dateTime": function (newVal) {
      if (!newVal) {
        this.queryParams.shippingDateBegin = "";
        this.queryParams.shippingDateEnd = "";
      }
    }
  },
  created() {
    this.getIncludeLeasee();
  },
  methods: {
    onDate(val) {
      if (!val) return;
      this.queryParams.shippingDateBegin = val[0].formatDate();
      this.queryParams.shippingDateEnd = val[1].formatDate();
    },
    async getIncludeLeasee() {
      let url = 'http://MID-OPERATE-LEASE/messageService/zhService/queryZHLeasees';
      this.includeList = await this.invoke(url, {});
    },
    onQuery() {
      this.$refs['tableRef'].loadFirstPage();
    },
    onLockSigin(businessNo,masterId){
        this.$router.push({path:"/user-center/lease/e-receipt-notes",query:{businessNo,masterId,backPath:'/user-center/lease/deliveryList'}})
    }
  }
}
</script>